export default __webpack_public_path__ + "static/media/img-appdownload-intro.fc486748.png";